var webooker_courses_models = webooker_courses_models || {};

(function (ns) {

    // #region CourseRegistrationInvoice - ctor
    ns.CourseRegistrationInvoice = function CourseRegistrationInvoice(coursePriceSvc, course, registeredAttendance, promotions, invoiceDTO) {

        var self = this;

        this.coursePriceSvc = coursePriceSvc;
        this.course = course;
        this.registeredAttendance = registeredAttendance;
        this.invoiceDTO = invoiceDTO;
        
        this.useAmortizationSchedule =
            (this.course.amortizationScheduleMode == 2 /* ForcedToAllClients */ && !this.invoiceDTO.invoiceID) ||
            (!!this.invoiceDTO.amortizationSchedules && !!this.invoiceDTO.amortizationSchedules.length);
        this._useAmortizationScheduleOrig = this.useAmortizationSchedule;
        this.amortizationScheduleSurchargePct = this.course.amortizationScheduleSurchargePct;

        //CourseFee = 1,
        //Discount = 2,
        //Membership = 3,
        //ManualAdjustment = 4,


        // Invoice
        //VAT: null
        //accountingBookID: 1
        //currency: "CZK"
        //customerOperatorID: 405
        //customerStudentID: 512
        //invoiceID: 313030
        //lineItems: Array[7]
        //total: 834.4

        // InvoiceLine
        //invoiceLineType: "CourseFee"
        //name: "Student: Nikola Brabcová Kurz: Baletní přípravka - 3 - 6 let - začátečníci - PO 16:00"
        //price: 960
        //quantity: null
        //typeReferenceID: 278090
        //unitPrice: null

        // Promotion
        //buy: false
        //description: null
        //discountPct: 5
        //isMandatory: false
        //membershipID: 110
        //name: "Volitelná sleva platná"
        //owns: true
        //price: 0

        this.dueDate = null;

        this.lines = [];
        // Course Fee Line

        var invoiceCourseFee = _.find(invoiceDTO.lineItems, { invoiceLineType: 'CourseFee' });
        this.lines.push(
            new webooker_courses_models.CourseRegistrationInvoiceLine(this, 'CourseFee', {
                owns: !!invoiceCourseFee,
                buy: !!invoiceCourseFee,
                name: invoiceCourseFee ? invoiceCourseFee.name : '',
                price: invoiceCourseFee ? invoiceCourseFee.price : '',
                discountPct: 0,
                isMandatory: 0,
                membershipID: null,
                description: null,
                isValid: true
            }, invoiceCourseFee)
        );

        // Find Memberships
        var invoiceMemberships = _.filter(invoiceDTO.lineItems, { invoiceLineType: 'Membership' });
        angular.forEach(promotions, function (item) {
            var invoiceMembership = _.find(invoiceMemberships, { typeReferenceID: item.membershipID });
            this.lines.push(
                new webooker_courses_models.CourseRegistrationInvoiceLine(this, 'Membership', {
                    owns: item.owns,
                    buy: item.buy,
                    name: item.name,
                    price: item.price,
                    discountPct: item.discountPct,
                    isMandatory: item.isMandatory,
                    membershipID: item.membershipID,
                    description: item.description,
                    isValid: true,
                    validFrom: item.validFrom,
                    validTo: item.validTo
                }, invoiceMembership)
            );
        }, this);

        angular.forEach(invoiceMemberships, function (item) {
            var promotion = _.find(promotions, { membershipID: item.typeReferenceID });
            if (!promotion) {
                this.lines.push(
                    new webooker_courses_models.CourseRegistrationInvoiceLine(this, 'Membership', {
                        owns: true,
                        buy: true,
                        name: item.name,
                        price: item.price,
                        discountPct: 0,
                        isMandatory: false,
                        membershipID: item.typeReferenceID,
                        description: null,
                        isValid: false
                    }, item));
                }
        }, this);

        var memberships = _.filter(this.lines, { lineType: 'Membership' });

        for (var i = 0; i < memberships.length; i++) {
            var m = memberships[i];
            var isInInvoice = _.find(invoiceDTO.lineItems, { invoiceLineType: 'Discount', typeReferenceID: m.membershipID });
            this.lines.push(
                new webooker_courses_models.CourseRegistrationInvoiceLine(this, 'Discount', m, isInInvoice)
            );
        }

        var invoiceDiscounts = _.filter(invoiceDTO.lineItems, { invoiceLineType: 'Discount' });
        _.forEach(invoiceDiscounts, function (discount) {
            var membership = _.find(memberships, { 'membershipID': discount.typeReferenceID });
            if (!membership) {
                // We do not have membership, this means the discount is in the invoice but 
                // it is not valid anymore
                self.lines.push(
                    new webooker_courses_models.CourseRegistrationInvoiceLine(self, 'Discount', {
                        owns: true,
                        buy: false,
                        name: discount.name,
                        price: discount.price,
                        discountPct: 0,
                        isMandatory: false,
                        membershipID: discount.typeReferenceID,
                        description: null,
                        isValid: false
                    }, discount));
            }
        });

        var manualsInInvoice = _.filter(invoiceDTO.lineItems, { invoiceLineType: 'ManualAdjustment' });
        _.forEach(manualsInInvoice, function (manualInInvoice) {
            self.lines.push(
                    new webooker_courses_models.CourseRegistrationInvoiceLine(self, 'ManualAdjustment', {
                        owns: !!manualInInvoice,
                        buy: !!manualInInvoice,
                        name: manualInInvoice ? manualInInvoice.name : '',
                        price: manualInInvoice ? manualInInvoice.price : '',
                        discountPct: 0,
                        isMandatory: 0,
                        membershipID: null,
                        description: null,
                        isValid: true
                    }, manualInInvoice)
                );
        });

        this.invoiceLinesOrig = angular.copy(self.lines);

        //if (manualsInInvoice.length == 0)
        //{
        //    self.lines.push(
        //            new webooker_courses_models.CourseRegistrationInvoiceLine(self, 'ManualAdjustment', {
        //                owns: false,
        //                buy: false,
        //                name: '',
        //                price: '',
        //                discountPct: 0,
        //                isMandatory: 0,
        //                membershipID: null,
        //                description: null,
        //                isValid: true
        //            }, null)
        //        );
        //}
    };
    // #endregion


    Object.defineProperty(ns.CourseRegistrationInvoice.prototype, 'noOfRegisteredAttendances', {
        enumerable: true, configurable: true,
        get: function () {
            return _.reduce(this.registeredAttendance, function (total, n) {
                if (n.isRegistered) {
                    return total + (n.attendanceCount || 1);
                } else {
                    return total;
                }
            }, 0);
        }
    });

    Object.defineProperty(ns.CourseRegistrationInvoice.prototype, 'membershipNow', {
        enumerable: true, configurable: true,
        get: function () {

            var promotionNow = this.course.registrationDate || new Date();

            var registeredLessons = _.sortBy(_.filter(this.registeredAttendance, { 'isRegistered': true }), 'startDate');

            if (registeredLessons && registeredLessons.length) {
                promotionNow = registeredLessons[0].startDate;
            }

            return moment(promotionNow).startOf('day').toDate();
        }
    });

    Object.defineProperty(ns.CourseRegistrationInvoice.prototype, 'total', {
        enumerable: true, configurable: true,
        get: function () {
             return _.reduce(this.lines, function (total, n) {
                if (n.isValid) {
                    return total + n.price;
                } else {
                    return total;
                }
            }, 0);
        }
    });

    Object.defineProperty(ns.CourseRegistrationInvoice.prototype, 'basePrice', {
        enumerable: true, configurable: true,
        get: function () {
            var courseFee = _.find(this.lines, { lineType: 'CourseFee' });
            return !!courseFee
                ? courseFee.price
                : 0;
        }
    });

    Object.defineProperty(ns.CourseRegistrationInvoice.prototype, 'isModified', {
        enumerable: true, configurable: true,
        get: function () {
            // Is any of the current lines modified?
            return _.reduce(this.lines, function (total, n) {                
                return total || n.isModified;
            }, false) || !!this.dueDate || (this._useAmortizationScheduleOrig != this.useAmortizationSchedule) || 
                !angular.equals(this.lines, this.invoiceLinesOrig);
        }
    });

    Object.defineProperty(ns.CourseRegistrationInvoice.prototype, 'totalByamortizationSchedule', {
        enumerable: true, configurable: true,
        get: function () {
            if (!!this.invoiceDTO.amortizationSchedules && !!this.invoiceDTO.amortizationSchedules.length) {
                // Calc by amortization schedule
                var mnow = moment().startOf('day');

                var totalByAmortizationSchedule = _.reduce(this.invoiceDTO.amortizationSchedules, function (total, n) {
                    if (moment(n.issueAt).isSameOrBefore(mnow)) {
                        return total + n.amount;
                    }

                    return total;
                }, 0);

                if (totalByAmortizationSchedule == 0 && this.invoiceDTO.amortizationSchedules.length > 0) {
                    totalByAmortizationSchedule = this.invoiceDTO.amortizationSchedules[0].amount;
                }

                return totalByAmortizationSchedule;
            }
            else {
                return _.reduce(this.invoiceDTO.lineItems, function (total, n) {
                        return total + n.price;
                }, 0);
            }
        }
    });


    ns.CourseRegistrationInvoice.prototype.toJSON = function () {
        return {
            dueDate: this.dueDate,
            lines: this.lines,
            useAmortizationSchedule: this.useAmortizationSchedule
        }
    }

    ns.CourseRegistrationInvoice.prototype.addManualAdjustmentLine = function (manualAdjustmentLineType) {
        var line = new webooker_courses_models.CourseRegistrationInvoiceLine(this, 'ManualAdjustment', {
            owns: false,
            buy: true,
            name: '',
            price: '',
            discountPct: 0,
            isMandatory: 0,
            membershipID: null,
            description: null,
            isValid: true
        }, null);
        line.runtimeManualAdjustmentType = manualAdjustmentLineType;

        this.lines.push(line);

        return line;
    }

    ns.CourseRegistrationInvoice.prototype.removeManualAdjustmentLine = function (line) {

        var index = this.lines.indexOf(line);
        if (index != -1) {
            this.lines.splice(index, 1);
        }
    }

})(webooker_courses_models);